import { Box, Typography, Divider, Chip } from '@mui/material';
// Define available MUI chip colors

function Academics({ academics, capitalizeWords  }) {
    // Handle new API structure where academics is directly an array, or old structure with academics.educations
    const educations = Array.isArray(academics) ? academics : (academics?.educations || []);
    
    if (!educations || educations.length === 0) {
        return null;
    }
    
    return (
        <Box sx={{ mx: 2 }}>
            <Typography variant="h5" sx={{ color: '#666', mb: 2 }}>Academic Credentials</Typography>
            <Box sx={{  mb: 2, mx: 2  }}> 
            {educations.map((academic, index) => (
                <Box sx={{ mb: 2 }} key={index}>    
                <Typography variant="h6" sx={{ color: '#888', fontWeight: 550 } }>
                    {capitalizeWords(academic.school)} - {capitalizeWords(Array.isArray(academic.degree) ? academic.degree.join(', ') : academic.degree)}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 5, mt: 0.5, mb: 0.5   }}>
                {academic.tenure && (    
                <Typography variant="subtitle2" sx={{ color: '#888' }}><b>Tenure:</b> {academic.tenure}</Typography>
                )}
                {academic.location && (
                    <Typography variant="subtitle2" sx={{ color: '#888' }}><b>Location:</b> {capitalizeWords(academic.location)}</Typography>
                )}
                </Box>
                {academic.summary && (
                    <Typography variant="subtitle2" sx={{ color: '#888' }}><b>Summary:</b> {academic.summary}</Typography>
                )}
                
                
                <Divider sx={{ mb: 2, mt: 2 }} />
            </Box>
        ))} 
        </Box> 
    </Box>
    )
}

export default Academics;